<template>
  <div class="related-products">
    <ProductCarousel
      v-if="products.length && mounted"
      class="similar-products-carousel"
      title="You Might Also Like"
      :products="similarProducts"
      :on-sale-filter="true"
      :to-send-event="true"
      :swiper-margin="swiperMargin"
    />
  </div>
</template>

<script>
import { onServerPrefetch, computed } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import ProductCarousel from '@/components/commons/ProductCarousel.vue';
import { formatPrice } from '@/components/commons/MoneyUtils.js';
import useSimilarProducts from '@/compositions/useSimilarProducts.js';

export default {
  name: 'SimilarProducts',
  components: {
    ProductCarousel
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    swiperMargin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mounted: false
    };
  },
  computed: {
    ...mapGetters('common', ['currentCountry']),

    similarProducts() {
      if(this.products) {
        return this.products.map(product => {
          const price = formatPrice(product, this.currentCountry);
          return {
            id: product.hashKey,
            skuNo: product.skuNo,
            title: product.title,
            isOnSale: product.onSale,
            isOnClearance: product.onClearance,
            price: price.finalFormatted,
            priceOriginal: price.priceFormatted,
            url: this.$router.resolve({ name: 'product', params: { id: product.hashKey, slug: product.slug } }).href,
            productImage: {
              url: `${product.imageUrl}?fit=max&w={width}&q={q}`
            }
          };
        });
      }
      return [];
    }
  },

  setup(props) {
    const {
      load,
      loading,
      products
    } = useSimilarProducts();

    const filter = computed(() => ({
      taxonomyCategories: [props.product.taxonomyCategory.id],
      taxonomyAttributes: props.product.taxonomyAttribute.map(attribute => attribute.attributeId),
      excludedProducts: [props.product.hashKey]
    }));

    onServerPrefetch(async () => {
      await load(filter.value);
    });

    return {
      load,
      loading,
      products,
      filter
    };
  },

  async mounted() {
    await this.load(this.filter);
    this.$emit('updated', this.products);
    this.mounted = true;
  }
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.related-products {
  .related-products-carousel {
    margin-bottom: 0px;
  }
  .title {
    margin-bottom: 24px;
  }

  .browse-heading {
    font-size: var(--font-size-14);
  }

  .price {
    font-size: 1.1em;
    color: var(--coral);
  }
}
</style>
